export default "<div class=\"xamin-blue-bg py-5\">\n  <div class=\"container\">\n      <app-counter [List]=\"list\"></app-counter>\n  </div>\n</div>\n"